import React, { useState } from "react";
import { ActivateFeedback } from "../../pages";
import { FeedbackController } from "../../controllers";
import constant from "../../utils/constant";
import { MimaToastUtil } from "../../components";

const ActivateFeedbackContainer = ({ data, closeModal }) => {
  const [loading, setLoading] = useState(false);

  const onSubmit = async (payload) => {
    setLoading(true);
    const { status, errorMessage } =
      await FeedbackController.updateFeedbackKeys(payload, data._id);
    if (status === constant.Success) {
      setLoading(false);
      closeModal();
      MimaToastUtil.success({
        message: constant.Success,
      });
    } else {
      MimaToastUtil.error({
        message: errorMessage,
      });
    }
    setLoading(false);
    return;
  };

  return (
    <ActivateFeedback
      data={data}
      closeModal={closeModal}
      loading={loading}
      onSubmit={onSubmit}
    />
  );
};
export default ActivateFeedbackContainer;
